/**
 * Maps an order item status value to a CSS class that applies row background/border/hover colors.
 * Classes are defined in src/styles/_statusColors.scss.
 */
const STATUS_CLASS_MAP: Record<string, string> = {
  APPROVED: 'row--status-approved',
  ASSIGNED: 'row--status-assigned',
  CUSTOMER_CANCELLED: 'row--status-customer-cancelled',
  DELIVERED: 'row--status-delivered',
  ENROUTE: 'row--status-enroute',
  INVOICED: 'row--status-invoiced',
  PAID: 'row--status-paid',
  PALLET: 'row--status-pallet',
  PREPAY_REQUIRED: 'row--status-prepay-required',
  RAILCAR: 'row--status-railcar',
  READY_FOR_PICKUP: 'row--status-ready-for-pickup',
  REJECTED: 'row--status-rejected',
  WAITLIST: 'row--status-waitlist',
  ON_HOLD: 'row--status-on-hold',
  INVENTORY: 'row--status-inventory',
};

export function getStatusRowClass(status: string | undefined): string {
  if (!status) return '';
  return STATUS_CLASS_MAP[status] ?? '';
}
